import { render } from "./MarredheniamePublikun.vue?vue&type=template&id=29cd9d08"
import script from "./MarredheniamePublikun.vue?vue&type=script&lang=js"
export * from "./MarredheniamePublikun.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__